import { apiHelper } from "./core"

const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const getAllCenters = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getCenterDetail = (id: any): Promise<any> => {
  // console.log("id from center id -->", id)

  return apiHelper
    .get(
      id
        ? `${masterServiceBaseUrl}/centers/${id}`
        : `${masterServiceBaseUrl}/centers`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const registerNotificationsToken = (data: any): Promise<any> => {
  let url = ""
  if (Object.keys(data)?.includes("token")) {
    if (Object.keys(data)?.includes("staffId")) {
      url = `push-notification/register-token?token=${
        data?.token
      }&userType=${data?.userType?.toUpperCase()}&staffId=${
        data?.staffId
      }&isWebToken=true`
    } else {
      url = `push-notification/register-token?token=${
        data?.token
      }&userType=${data?.userType?.toUpperCase()}&patientId=${
        data?.patientId
      }&isWebToken=true`
    }
  }

  return apiHelper
    .post(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const clearNotificationsToken = (data: any): Promise<any> => {
  let url = ""
  if (Object.keys(data)?.includes("token")) {
    if (Object.keys(data)?.includes("staffId")) {
      url = `push-notification/clear-token?token=${
        data?.token
      }&userType=${data?.userType?.toUpperCase()}&staffId=${
        data?.staffId
      }&isWebToken=true`
    } else {
      url = `push-notification/clear-token?token=${
        data?.token
      }&userType=${data?.userType?.toUpperCase()}&patientId=${
        data?.patientId
      }&isWebToken=true`
    }
  }

  return apiHelper
    .post(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getPushNotifications = (userId: string, page: number): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/push-notification-details?userId=${userId}&page=${page}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const createCenterDetail = (body: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/centers`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateCenterDetail = (centerId: string, body: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/centers/${centerId}`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getFrequencies = (centerId: string): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/centers/${centerId}/get-frequencies-for-medication`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateFrequencies = (centerId: string, values: any): Promise<any> => {
  return apiHelper
    .put(
      `${masterServiceBaseUrl}/centers/${centerId}/update-frequency-list`,
      values
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getDrugs = (query: string | null = null): Promise<any> => {
  const url = query ? `drugs${query}` : "drugs"

  return apiHelper
    .get(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAllWondersoftDrugs = (query: string | null = null): Promise<any> => {
  const url = query
    ? `wondersoft/search-drugs${query}`
    : "wondersoft/search-drugs"

  return apiHelper
    .get(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const filterWondersoftDrugs = (query: string | null = null): Promise<any> => {
  const url = query
    ? `wondersoft/search-drugs${query}`
    : "wondersoft/search-drugs"

  return apiHelper
    .get(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getDrugByDrugId = (drugId: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/drugs/${drugId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getDrugByName = (name: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/drugs?genericName=${name}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getConsentForms = (info: any): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/consents?appointmentId=${info?.appointmentId}&consentStatus=${info?.type}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getConsentFormsById = (id: any, appId?: any): Promise<any> => {
  let url = ""
  url += `form-templates/${id}`
  if (appId) {
    url += `?appointmentId=${appId}`
  }
  return apiHelper
    .get(`${masterServiceBaseUrl}/${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const saveConsentForm = (payload: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/consents`, payload)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateConsentForm = (payload: any, id: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/consents/${id}`, payload)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updatePrintConfiguration = (payload: any): Promise<any> => {
  return apiHelper
    .put(`${masterServiceBaseUrl}/system-admin/print-configuration`, payload)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getServerPrintConfiguration = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/system-admin/print-configuration`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const sendClinicalPdfData = (body: any, id: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/consents/${id}/send`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * Returns all form template types that are applicable.
 *
 * @returns
 */
const getAllFormTemplateTypes = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/system-admin/form-templates/get-types`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * Returns all form templates based upon given form type.
 *
 * @param type Template type
 * @returns
 */
const getAllFormTemplatesByType = (type: string): Promise<any> => {
  return apiHelper
    .get(
      `${masterServiceBaseUrl}/system-admin/form-templates/get-names?type=${type}`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * Returns a form template details by form template id.
 *
 * @param id Template id
 * @returns
 */

//Get form Template Read and Write Information
const getFormReadAndWriteByType = (type: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/system-admin/form-templates?type=${type}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Update Form and Templates of a given type at once
const UpdateAllFormTemplateReadWrite = (values: any): Promise<any> => {
  return apiHelper
    .patch(`${masterServiceBaseUrl}/system-admin/form-templates`, values)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Update Form and Templates
const UpdateFormTemplateReadWrite = (id: any, values: any): Promise<any> => {
  return apiHelper
    .patch(`${masterServiceBaseUrl}/system-admin/form-templates/${id}`, values)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Soft Delete form-delete
const deleteFormTemplate = (id: string): Promise<any> => {
  return apiHelper
    .delete(`${masterServiceBaseUrl}/system-admin/form-template/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getFormTemplateById = (id: string): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/system-admin/form-templates/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/**
 * Updates (patches) given form template with given details.
 *
 * @param id Template id
 * @param input Patch (partial) object
 * @returns
 */
const patchFormTemplate = (id: string, input: any): Promise<any> => {
  return apiHelper
    .patch(`${masterServiceBaseUrl}/system-admin/form-templates/${id}`, input)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
//Get ALL services
const getAllMasterServices = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/services`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
//Upload form JSON
const saveFormTemplateSystemAdmin = (values: any): Promise<any> => {
  return apiHelper
    .patch(`${masterServiceBaseUrl}/system-admin/form-templates`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

//Add New Form Template
const addFormTemplate = (values: any): Promise<any> => {
  return apiHelper
    .post(`${masterServiceBaseUrl}/system-admin/form-templates`, values)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  updateFrequencies,
  getFrequencies,
  getAllCenters,
  getDrugs,
  getDrugByDrugId,
  getCenterDetail,
  createCenterDetail,
  updateCenterDetail,
  getConsentForms,
  updatePrintConfiguration,
  saveConsentForm,
  updateConsentForm,
  sendClinicalPdfData,
  getPushNotifications,
  registerNotificationsToken,
  clearNotificationsToken,
  getDrugByName,
  addFormTemplate,
  getAllFormTemplateTypes,
  getAllFormTemplatesByType,
  getFormTemplateById,
  patchFormTemplate,
  saveFormTemplateSystemAdmin,
  getFormReadAndWriteByType,
  UpdateAllFormTemplateReadWrite,
  getServerPrintConfiguration,
  getConsentFormsById,
  getAllMasterServices,
  deleteFormTemplate,
  UpdateFormTemplateReadWrite,
  getAllWondersoftDrugs,
  filterWondersoftDrugs,
}
